import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export default registerMPElement(
  `mp-radio-button`,
  class extends Component<{}> {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        disabled: `boolean`,
        icon: `string`,
        selected: `boolean`,
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
      };
    }
  },
);
